import { Component, OnInit, EventEmitter, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent implements OnInit {

  onDataRecieved = new EventEmitter();
  private _isDecisionEmitted = false;
  constructor(
    public dialogRef: MatDialogRef<ConfirmModalComponent>,
    private _domSanitizer: DomSanitizer,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.data.description = this._domSanitizer.bypassSecurityTrustHtml(this.data.description);
  }

  ngOnInit(){
    this.dialogRef.afterClosed().subscribe(() => {
      if (!this._isDecisionEmitted) {
        this.onDataRecieved.emit(false);
      }
    });
  }

  onClickYes(): void {
    this._isDecisionEmitted = true;
    this.dialogRef.close();
    this.onDataRecieved.emit(true);
  }

  onClickNo(): void {
    this._isDecisionEmitted = true;
    this.dialogRef.close();
    // this.onDataRecieved.emit(false);
  }

  closeDialog():void{
    this._isDecisionEmitted = true;
    // this.onDataRecieved.emit(false);
    this.dialogRef.close();
  }

}
